import 'date-fns';
import React from 'react';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const DatePickerCustom = (props) => {
    const { margin, id, label, value, onChange,
        error, required } = props
    return <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
            disableToolbar
            format="MM/dd/yyyy"
            defaultValue={null}
            required={required}
            margin={margin}
            id={id}
            label={label}
            value={value}
            fullWidth={true}
            error={!!error}
            helperText={error}
            onChange={onChange}
        />
    </MuiPickersUtilsProvider>
}

export default DatePickerCustom
